import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import DiscussionHero from 'flarum/forum/components/DiscussionHero';
import Button from 'flarum/common/components/Button';
import Handler from '../Checkout/Handler';
import type Discussion from 'flarum/common/models/Discussion';

export default function () {
  const requiresPayToPost = function (discussion: Discussion) {
    const tags = discussion.tags() || [];
    const ptpTags = tags.filter((tag) => tag && tag.blomstraPtpProduct());

    return !discussion.blomstraPtpPaid() && ptpTags.length > 0;
  };

  const payToPost = function (discussion: Discussion) {
    const handler = new Handler('ptp', {
      discussion: discussion.id(),
    });

    handler.checkout();
  };

  extend(DiscussionHero.prototype, 'items', function (this: DiscussionHero, items) {
    // @ts-ignore not typed in core yet
    const discussion: Discussion = this.attrs.discussion;

    if (requiresPayToPost(discussion)) {
      items.add(
        'blomstraPtpProduct',
        <div className="Blomstra-Payments">
          <div className="description Hero-subtitle">{app.translator.trans('floxum-payments.forum.pay-to-post.purchase_required')}</div>
          <Button onclick={() => payToPost(discussion)} className="Button Button--square" icon="fas fa-shopping-cart">
            {app.translator.trans('floxum-payments.forum.pay-to-post.purchase')}
          </Button>
        </div>
      );
    }
  });

  extend(DiscussionPage.prototype, 'sidebarItems', function (this: DiscussionPage, items) {
    if (requiresPayToPost(this.discussion!)) {
      const operation = items.has('controls') ? items.setContent.bind(items) : items.add.bind(items);

      operation(
        'controls',
        <Button onclick={() => payToPost(this.discussion!)} className="Button Button--primary">
          {app.translator.trans('floxum-payments.forum.pay-to-post.purchase-control')}
        </Button>
      );
    }
  });
}
